import script from "./MessageContentHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageContentHeader.vue?vue&type=script&setup=true&lang=js"

import "./MessageContentHeader.vue?vue&type=style&index=0&id=d491e512&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d491e512"]])

export default __exports__